import { ImageScaleView, animate } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import { FeatureButton } from 'src/game/components/FeatureButton';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { canShowStarterPackHomeButton } from '../starterpack.utils';
import { now, user } from 'src/StateObserver';
import { animDuration } from 'src/lib/utils';
import { getRemainingStarterPackPromoTime } from 'src/replicant/starterpack/starterpack.getters';

export class StarterPackButton extends FeatureButton {
  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 160,
      pressedOffsetY: 5,
      labelPanel: {
        offsetX: -2,
        offsetY: -7,
      },
      ...opts,
    });

    new ImageScaleView({
      superview: this.container,
      width: downscale(250),
      height: downscale(250),
      scaleMethod: 'contain',
      image: 'assets/ui/starterPack/button.png',
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
    });

    this.container.hide();
  }

  public update() {
    if (!canShowStarterPackHomeButton(user(), now())) {
      this.hide();
      this.container.hide();
      return;
    }
    if (!this.container.style.visible) {
      this.container.updateOpts({ scale: 0 });
      animate(this.container).now(
        { scale: 1 },
        animDuration,
        animate.easeOutBack,
      );
    }

    this.show();
    this.container.show();
    this.setLabelTime({
      duration: Math.max(getRemainingStarterPackPromoTime(user(), now()), 0),
      roundUp: true,
    });
  }
}
